import { SearchOutlined } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { Checkbox, Col, Input, Row, Spin, Tag } from 'antd';
import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';

interface ISymbolItem {
  symbolName: string;
  iconDayUrl: string;
  symbolId: number;
}

const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

interface ISymbolListProps {
  allSymbols: ISymbolItem[];
  selfSymbols: string[];
  activeTabKey: string;
  loadingSymbols: boolean;
  onDelete: (symbolName: string) => void;
  onChangeWhiteList: (symbolNameList: string[]) => void;
}

const SymbolList: FC<ISymbolListProps> = ({
  allSymbols,
  selfSymbols,
  activeTabKey,
  loadingSymbols,
  onDelete,
  onChangeWhiteList,
}) => {
  const [$t] = useI18nContext();
  const [searchInput, setSearchInput] = useState<string>('');
  const [symbolList, setSymbolList] = useState<ISymbolItem[]>([]);

  useEffect(() => {
    console.log('api-management-activeTabKey', activeTabKey);
    setSearchInput('');
  }, [activeTabKey]);

  useEffect(() => {
    console.log('api-management-allSymbols', allSymbols);
    setSymbolList(allSymbols);
  }, [allSymbols]);

  // 搜索过滤
  const onInputChange = (e: any) => {
    const value = e.target.value;
    setSearchInput(value);
    if (value) {
      setSymbolList(
        allSymbols.filter(
          (item) =>
            item.symbolName.toLowerCase().indexOf(value.trim().toLowerCase()) >
            -1,
        ),
      );
    } else {
      setSymbolList(allSymbols);
    }
  };

  // 白名单变更
  const changeWhiteList = (e: any) => {
    console.log('api-management-searchInput', searchInput, e);
    if (searchInput) {
      const outerSymbolArr = selfSymbols.filter(
        (item: string) =>
          item.toLowerCase().indexOf(searchInput.toLowerCase()) === -1,
      );
      onChangeWhiteList([...outerSymbolArr, ...e]);
    } else {
      onChangeWhiteList(e);
    }
  };

  // 删除某个交易对
  const handleClose = (removedTag: string) => {
    onDelete(removedTag);
  };
  const forMap = (tag: string) => {
    const symbol = allSymbols.filter((item: any) => item.symbolId === tag);
    if (symbol?.length !== 1) return;
    const tagElem = (
      <Tag
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
        style={{ marginBottom: 8 }}
      >
        {symbol[0]?.symbolName}
      </Tag>
    );
    return (
      <span key={tag} style={{ display: 'inline-block' }}>
        {tagElem}
      </span>
    );
  };
  const tagChild = selfSymbols.map(forMap);

  return (
    <>
      <Spin indicator={antIcon} spinning={loadingSymbols}>
        <div className={classNames('self-symbol-container', 'margin-bottom-8')}>
          {!loadingSymbols && tagChild}
        </div>
        <div>
          <div className={classNames('margin-bottom-16', 'searchContianer')}>
            <Input
              className="search-input"
              size="middle"
              value={searchInput}
              placeholder={$t('Search')}
              prefix={<SearchOutlined />}
              onChange={onInputChange}
              onPressEnter={onInputChange}
            />
          </div>
          <div className="symbols">
            <Checkbox.Group
              value={selfSymbols}
              style={{ width: '100%' }}
              onChange={changeWhiteList}
            >
              <Row>
                {symbolList.map((item: any, index: number) => {
                  return (
                    <Col
                      key={`${activeTabKey}_${item.symbolName}_${index}`}
                      className={classNames('symbol-item', {
                        'margin-top-16': index > 1,
                      })}
                      span={12}
                    >
                      <Checkbox
                        checked={selfSymbols.indexOf(item.symbolId) > -1}
                        value={item?.symbolId}
                      >
                        <img
                          className="symbol-icon"
                          alt={''}
                          src={item?.iconDayUrl}
                          width="24"
                          height="24"
                        />
                        <span className={classNames('margin-left-10')}>
                          {item.symbolName}
                        </span>
                      </Checkbox>
                    </Col>
                  );
                })}
              </Row>
            </Checkbox.Group>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default SymbolList;
